<template>
    <div class="ClusterAvailability">
        <div v-for="(cluster, cluster_index) in availableClusterList" :key="cluster_index">
            <div class="title mt-4">{{cluster.store_name  }}</div>

            <table class="mt-4">
                <thead>
                    <tr>
                        <th>EMPLOYEE</th>
                        <!-- <th>DEPARTMENT</th> -->
                        <th>FUNCTION</th>
                        <th>TYPE</th>
                        <th>GENDER</th>
                        <th>TIME</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(emp, emp_index) in cluster.emp_list" :key="emp_index">
                        <td style="font-weight: bold;">{{ emp.full_name }}</td>
                        <!-- <td>{{ emp.department ? emp.department : '-' }}</td> -->
                        <td>{{ emp.function_name }}</td>
                        <td>{{ emp.employee_type }}</td>
                        <td>{{ emp.gender }}</td>
                        <td>
                            <span v-if="emp.start_time || emp.end_time">
                                {{ moment(emp.start_time).format('HH:mm A') }} - {{ moment(emp.end_time).format('HH:mm A') }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </td>
                        <td>
                            <div class="status-badge" :class="[emp.status == 'AVAILABLE' ? 'active' : (emp.status == 'UNAVAILABLE') ? 'in-active' : emp.status == 'PENDING' ? 'pending' : emp.status == 'APPROVED' ? 'approved' : emp.status == 'REJECTED' ? 'rejected' : '']" @click="openChangeClusterRequestDialog(cluster_index, emp_index)">
                                {{ emp.status }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!cluster.emp_list.length" class="no-data-notification">
                No data available
            </div>
        </div>

        <div v-if="!availableClusterList.length" class="no-data-notification">
            No data available
        </div>

        <!-- <el-dialog
			title="Request Employee"
			:visible.sync="change_request_status_dialog_visible"
			width="60%"
			:before-close="closeChangeRequestStatusDialog"
		>
			<div class="border-b pb-4">
                <div class="flex justify-between items-center">
                    <h4 class="heightlight-username text-lg capitalize">
                        {{ selected_emp.full_name }}
                    </h4>
                    <p class="float-right font-semibold text-lg text">
                        {{ current_date }}
                    </p>

                </div>
			</div>
 
            <div class="mt-4">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                        <div>
                            <p class="label">Start Time<span style="color: red;">*</span></p>
                            <el-select
                                v-model="shift_start_time"
                                v-validate="'required'"
                                placeholder="Start Time"
                                style="width: 100%;"
                                name="Start time"
                                filterable
                                :disabled="selected_emp.status == 'UNAVAILABLE' ? false : (shift_start_time !='' && selected_emp.employee_type == 'Part Time' ? true : false)"
                                @change="setEndTime()"
                            >
                                <el-option
                                    v-for="item in time_list"
                                    :key="item.time"
                                    :label="item.time"
                                    :value="item.datetime"
                                    :disabled="new Date(selected_emp.start_time) > new Date(item.datetime) || new Date(item.datetime) > new Date(selected_emp.end_time)"
                                >
                                </el-option>
                            </el-select>
                            <p>
                                <span :v-show="errors.has(`Start time`)" class=" text-red-dark text-xs">
                                    {{ errors.first(`Start time`) }}
                                </span>
                            </p>
                        </div>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                        <div>
                            <p class="label">
                                End Time <span style="color:red;">*</span>
                            </p>
                            <el-select
                                v-model="shift_end_time"
                                v-validate="'required'"
                                style="width: 100%;"
                                name="End time"
                                placeholder="End Time"
                                :disabled="selected_emp.status == 'UNAVAILABLE' ? false : !shift_start_time || selected_emp.employee_type == 'Part Time' ? true : false"
                                filterable
                            >
                                <el-option
                                    v-for="item in time_list"
                                    :key="item.time"
                                    :label="item.time"
                                    :value="item.datetime"
                                    :disabled="new Date(shift_start_time) > new Date(item.datetime) || new Date(selected_emp.end_time) < new Date(item.datetime)"
                                >
                                </el-option>
                            </el-select>
                            <p>
                                <span :v-show="errors.has(`End time`)" class=" text-red-dark text-xs">
                                    {{ errors.first(`End time`) }}
                                </span>
                            </p>
                        </div>
                    </el-col>
                </el-row>

                <el-row class="mt-4" :gutter="20">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                        <p class="label">Function</p>
                        <el-input v-model="selected_emp.function_name" style="width: 100%" disabled></el-input> 
                    </el-col>
                </el-row>

                <div class="mt-4">
                    <p class="label">Notes (Optional)</p>
                    <el-input
                        v-model="notes"
                        type="textarea"
                        resize="none"
                        :rows="3"
                        placeholder="Please input"
                        name="Notes">
                    </el-input>
                    <p>
                        <span :v-show="errors.has(`Notes`)" class=" text-red-dark text-xs">
                            {{ errors.first(`Notes`) }}
                        </span>
                    </p>
                </div>
            </div>

            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
                <el-button class="action-btn" size="small" @click="change_request_status_dialog_visible = false">
                    CANCEL
                </el-button>
                <el-button class="action-btn" size="small" @click="sendRequest()" :loading="is_request_in_process">
                    REQUEST
                </el-button>
            </div>
		</el-dialog> -->

        <!-- dialog to show error in request -->
		<el-dialog
			title="Error"
			:visible.sync="request_error_dialog_visible"
			width="50%"
			:before-close="closeRequestErrorDialog"
			
		>
			<div class="text-base">
				{{ request_error }}
			</div>

			<div style="display: flex; justify-content: flex-end; margin-top: 10px;">
                <el-button class="action-btn" size="small" @click="request_error_dialog_visible = false">
                    OK
                </el-button>
            </div>

		</el-dialog>

        <!-- Cluster popup -->
  <div v-if="(checkCompany.is_sb_malaysia || checkCompany.is_sb_india) && change_request_status_dialog_visible">
        <el-dialog title="Request Employee" :visible.sync="change_request_status_dialog_visible" width="65%" custom-class="ns-cluster-dialog" :before-close="closeChangeRequestStatusDialog">
    			<div class="px-2 mt-1 text-center">
            <!-- v-loading="shiftLoader" -->
            <div class="nymb-shft-popup text-left">
              <span class="flex items-center justify-between mb-5 border-b pb-4">
                <h4 class="heightlight-username text-lg capitalize mr-2 emp-name-ellipsis">
                  {{ selected_emp.full_name }}
                </h4>
                <h4 class="heightlight-username text-lg capitalize mr-2 emp-name-ellipsis">
                  {{ moment(selected_emp.date).format('ll') }}
                </h4>
              </span>
              <el-row :gutter="10" class="mt-3">

                <!-- <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                  <p class="label-font font-bold my-1"> Shift Name </p>
                  <el-select v-model="shiftNameSelection" placeholder="Select" @change="changeShiftTimeByName()">
                    <el-option v-for="shiftName in customShiftsNameStore" :key="'shift-name-' + shiftName.id" :label="shiftName.name" :value="shiftName.id">
                    </el-option>
                    <el-option  key="custom-shift" label="Custom" :value="0"></el-option>
                  </el-select>
                </el-col> -->

                <el-col :xs="24" :sm="6" :md="5" :lg="5" :xl="6">
                  <p class="label-font font-bold my-1">
                    Start Time<span style="color: red">*</span>
                  </p>
                  <DateTimePicker v-model="selected_emp.start_time" v-validate="'required'" :displayed-value="selected_emp.start_time" name="Start time" :shift-time-slots="cluster_start_shift_time_slots"  label="Time"  @change="addCLshiftEndTimeAccoringToEmployeeTime()"/>

                  <p>
                    <span :v-show="errors.has(`Start time`)" class="text-red-dark text-xs">
                      {{ errors.first(`Start time`) ? 'Required field' : '' }}
                    </span>
                  </p>
                </el-col>

                <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="6">
                  <p class="label-font font-bold my-1">
                    End Time<span style="color: red">*</span>
                  </p>
                  <DateTimePicker v-model="selected_emp.end_time" v-validate="'required'" :displayed-value="selected_emp.end_time" :disabled-condition="selected_emp.start_time" name="End time" 
                  :shift-time-slots="cluster_end_shift_time_slots" :disabled="!cluster_end_shift_time_slots.length && !selected_emp.end_time"
                  label="Time"  @change="changedClusterEndTime(selected_emp.end_time)"/>

                  <p>
                    <span :v-show="errors.has(`End time`)" class="text-red-dark text-xs">
                      {{ errors.first(`End time`) ? 'Required field' : '' }}
                    </span>
                  </p>
                </el-col>

                <el-col v-if="!checkClusterSplit" :xs="24" :sm="6" :md="6" :lg="5" :xl="5">
                  <p class="label-font font-bold my-1">
                    Function<span style="color: red">*</span>
                  </p>
                  <el-select v-model="selected_emp.function_id" v-validate="!checkClusterSplit ? 'required' : ''" :disabled="true" filterable  style="width: 100%" name="Function"
                    placeholder="Select Function" @change="changedFunction()">
                    <el-option v-for="item in function_list" :key="item.id" :disabled="item.function == 'Excess' || item.function == 'Break'"   :label="item.function" :value="item.id">
                    </el-option>
                  </el-select>
                  <p>
                    <span :v-show="errors.has(`Function`)" class="text-red-dark text-xs">
                      {{ errors.first(`Function`) ? 'Required field' : '' }}
                    </span>
                  </p>
                </el-col>

                <el-col :xs="24" :sm="3" :md="3" :lg="3" :xl="3">
                  <div style="margin-top: 30px">
                    <!-- if selected emp has only one shift then disabled split shift option -->
                    <el-checkbox v-model="checkClusterSplit" @change="changeClusterSplitShift('changed')">Split Shift</el-checkbox>
                    <!-- <el-checkbox v-model="checkClusterSplit" @change="addMoreSpliteShift('changed')" :disabled="common_shifts.length == 1">Split Shift</el-checkbox> -->
                  </div>
                </el-col>

              </el-row>

              <!-- Over time and duration -->
              <div class="ns-ot-sd-sec my-4 text-left">
                <el-row :gutter="10" class="mt-3">
                  <el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
                    <span v-if="clusterShiftDuration" class="mr-5 font-base"> <strong> Shift Duration </strong> {{ clusterShiftDuration + ' Hrs' }}</span>
                    <span v-if="clusterOvertimeDuration > 0" class="font-base"> <strong> Overtime </strong> {{ clusterOvertimeDuration + ' Hrs' }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
                  </el-col>
                </el-row>
              </div>
              <!-- Over time and duration -->

              <div v-if="selected_emp.split_shifts.length && checkClusterSplit">
                <div v-for="(shift, shift_Index) in selected_emp.split_shifts" :key="shift_Index">
                  <el-row :gutter="20">

                    <el-col :xs="24" :sm="1" :md="1" :lg="1" :xl="1">
                      <div :style="{ 'margin-top': shift_Index == 0 ? '45px' : '30px' }">
                        {{ shift_Index + 1 }}
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                      <div class="mt-4">
                        <p v-if="shift_Index == 0" class="label-font font-bold">
                          Start Time<span style="color: red">*</span> :
                        </p>

                        <DateTimePicker v-model="shift.start_time" disabled v-validate="selected_emp.split_shifts.length && checkClusterSplit ? 'required' : ''" :displayed-value="shift.start_time"
                          :shift-time-slots="generateTimeSlotsForDateTimePickerByFunc(selected_emp.start_time)" :name="`Start time` + shift_Index"
                          label="Time"  @change="changedClusterTime(shift_Index)"/>
                        <p>
                          <span :v-show="errors.has(`Start time${shift_Index}`)" class="text-red-dark text-xs">
                            {{ errors.first(`Start time${shift_Index}`) ? 'Required field' : '' }}
                          </span>
                        </p>
                      </div>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                      <div class="mt-4">
                        <p v-if="shift_Index == 0" class="label-font font-bold">
                          End Time <span style="color: red">*</span> :
                        </p>
                        <DateTimePicker v-model="shift.end_time" v-validate="selected_emp.split_shifts.length && checkClusterSplit ? 'required' : ''" :disabled-condition="shift.start_time" :displayed-value="shift.end_time" :name="`End time` + shiftIndex"
                          :shift-time-slots="generateTimeSlotsForDateTimePickerByFunc(selected_emp.start_time, selected_emp.end_time)"
                          label="Time"  @change="changedClusterSplitEndTime(shift.end_time, shift_Index)" :disabled="shift_Index == selected_emp.split_shifts.length - 1"/>

                        <p>
                          <span :v-show="errors.has(`End time${shift_Index}`)" class="text-red-dark text-xs">
                            {{ errors.first(`End time${shift_Index}`) ? 'Required field' : '' }}
                          </span>
                        </p>
                      </div>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5">
                      <div class="mt-4">
                        <p v-if="shift_Index == 0" class="label-font font-bold">
                          Function<span style="color: red">*</span>
                        </p>
                        <el-select v-model="shift.function" v-validate="selected_emp.split_shifts.length && checkClusterSplit ? 'required' : ''" filterable style="width: 100%"
                          :name="'function' + shift_Index" placeholder="Select Function" @change="changedClusterFunction()">
                          <el-option v-for="item in function_list" :key="item.id" :disabled="item.function == 'Excess' || item.function == 'Break'" :label="item.function"
                            :value="item.id">
                          </el-option>
                        </el-select>
                        <p>
                          <span :v-show="errors.has(`function${shift_Index}`)" class="text-red-dark text-xs">
                            {{ errors.first(`function${shift_Index}`) ? 'Required field' : '' }}
                          </span>
                        </p>
                      </div>
                    </el-col>

                    <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
                      <div :style="{ 'margin-top': shift_Index == 0 ? '40px' : '25px' }">
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18px"
                          style="vertical-align: middle" @click="deleteClusterSingleShift(shift, shift_Index)" />
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <BaseButton v-if="selected_emp.split_shifts.length < 5 && checkClusterSplit" type="submit" class="w-24 mr-4 pt-4"
                buttonclass="btn p-2 text-xs " @click="addClusterNewSplitShift('add')">
                Add Split
              </BaseButton>

              <el-row class="mt-1 text-left">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-checkbox v-model="checkClusterBreaks" @change="enableClusterBreaks('changed')">Breaks</el-checkbox>
                </el-col>
              </el-row>

              <el-row v-if="checkClusterBreaks" :gutter="10" class="mt-3">
                <el-col v-for="(break_item, break_index) in selected_emp.breaks" :key="break_index" class="mb-3 text-left" :xs="24" :sm="12" :md="12" :lg="12"
                  :xl="12">
                  <div style="font-weight: bold; margin-top: 10px">
                    Break {{ break_index + 1 }}
                  </div>
                  <el-row :gutter="10" class="mt-3">
                    <el-col :xs="24" :sm="11" :md="11" :lg="11" :xl="11">
                      <p class="label-font my-1">Start Time</p>
                      <DateTimePicker v-model="break_item.start_time" v-validate="checkClusterBreaks ? 'required' : ''" :disabled="!selected_emp.start_time && !selected_emp.end_time" :displayed-value="break_item.start_time" name="Break Start time" 
                      :shift-time-slots="generateTimeSlotsForDateTimePickerByFunc(selected_emp.start_time, selected_emp.end_time)"
                      label="Time" @change="
                          AddClusterEndBreakTime(break_index, break_item.start_time)"/>
                      <span :v-show="errors.has(`Break Start time`)" class="text-red-dark text-xs">
                        {{ errors.first(`Break Start time`) ? 'Required field' : '' }}
                      </span>
                    </el-col>

                    <el-col :xs="24" :sm="11" :md="11" :lg="11" :xl="11">
                      <p class="label-font my-1">End Time</p>
                      <DateTimePicker v-model="break_item.end_time" v-validate="checkClusterBreaks ? 'required' : ''" :displayed-value="break_item.end_time" name="Break End time" 
                      :shift-time-slots="break_item.start_time ? generateTimeSlotsForDateTimePickerByFuncForBrk(break_item.start_time, selected_emp.end_time) : []"
                      label="Time"/>

                      <span :v-show="errors.has(`Break End time`)" class="text-red-dark text-xs">
                        {{ errors.first(`Break End time`) ? 'Required field' : '' }}
                      </span>
                    </el-col>

                    <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
                      <div>
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" :class="[break_index === 0 ? 'disabled cursor-not-allowed' : '']" width="18px"
                          style="vertical-align: middle; margin-top: 35px" @click="break_index !== 0 ? removeClusterBreak(break_item, break_index) : ''" />
                      </div>
                    </el-col>

                  </el-row>
                </el-col>
                <BaseButton v-if="checkClusterBreaks" type="submit" class="w-24 mr-4 pt-4 ns-brk-btn"
                  buttonclass="btn p-2 text-xs " @click="addClusterNewBreak('add')">
                  Add Break
                </BaseButton>
              </el-row>
        
            </div>
    			</div>
    			<div slot="footer" class="dialog-footer mt-2">
    				  <!-- Action Btns -->
                <span
                style="display: flex; justify-content: flex-end; margin-top: 10px">
                <BaseButton type="submit" class="w-24 mr-4" buttonclass="btn p-2 text-xs " @click="closeClusterDialog()">
                  Cancel
                </BaseButton>

                <BaseButton type="submit" class="w-24 mr-4" buttonclass="btn p-2 text-xs "
                  @click="createUpdateClusterShift()">
                  Request
                </BaseButton>
              </span>
    			</div>
    		</el-dialog>
      </div>
    		<!-- Cluster popup -->
    </div>
</template>

<script>
import moment from 'moment';
import labourPlanningService from '../../../../services/labourPalnningService';
import DateTimePicker from '../../../picker/DateTimePicker.vue';

export default {
    name: 'ClusterAvailability',
    components:{
        DateTimePicker
    },
    props: {
        availableClusterList: {
			type: Array,
			default: () => []
		},
        functions_list: {
			type: Array,
			default: () => []
		},
        selectStore: {
			type: String,
			default: () => ''
		},
        staffData: {
			type: Object,
			default: () => {}
		},
        storeTimeSlots: {
			type: Object,
			default: () => {}
		},
    },

    data(){
        return{
            change_request_status_dialog_visible: false,
            request_error_dialog_visible: false,
            request_error: '',
            selected_emp: {},
            current_date: '',
            shift_start_time: '',
            shift_end_time: '',
            select_function: '',
            time_list: [],
            notes: '',
            is_request_in_process: false,
            moment: moment,
            cluster_start_shift_time_slots: [],
            cluster_end_shift_time_slots: [],
            checkClusterSplit: false,
            clusterShiftDuration: 0,
            clusterOvertimeDuration: 0,
            checkClusterBreaks: false
        }
    },

    computed: {
        checkCompany(){
            let data = JSON.parse(localStorage.getItem('check_company'));
            return data;
        },
        function_list(){
            let data = [...this.functions_list];
            return data;
        },
    },
    mounted(){
       
    },
    methods: {
        openChangeClusterRequestDialog(cluster_index, emp_index){
            console.log(this.availableClusterList[cluster_index].emp_list[emp_index]);
            if(this.availableClusterList[cluster_index].emp_list[emp_index].status == 'AVAILABLE' || this.availableClusterList[cluster_index].emp_list[emp_index].status == 'PENDING' || this.availableClusterList[cluster_index].emp_list[emp_index].status == 'UNAVAILABLE'){
                
                this.selected_emp = this.availableClusterList[cluster_index].emp_list[emp_index];
                // Check splits and breaks
                if(this.selected_emp.split_shifts.length) {
                  this.checkClusterSplit = true;
                }
                if(this.selected_emp.breaks.length) {
                  this.checkClusterBreaks = true;
                }

                this.select_function = this.availableClusterList[cluster_index].emp_list[emp_index].function;
                this.selected_emp.source_outlet = this.availableClusterList[cluster_index].store_id;
                this.selected_emp.source_outlet_name = this.availableClusterList[cluster_index].store_name;
                this.selected_emp.cluster_index = cluster_index;
                this.selected_emp.emp_index = emp_index;

                this.current_date = moment(this.selected_emp.date).format('ddd MMM DD YYYY');

                this.shift_start_time = this.selected_emp.start_time ? moment(this.selected_emp.start_time).format('YYYY-MM-DD HH:mm') : '';
                this.shift_end_time = this.selected_emp.end_time ? moment(this.selected_emp.end_time).format('YYYY-MM-DD HH:mm') : '';

                this.getScheduleTimeForTimePicker(this.current_date);   //fill time lables

                this.change_request_status_dialog_visible = true;     //if emp is available then opened dialog
                this.generateAllTimeSlotForClusterShift(this.selected_emp.date);
            }
        },
        closeClusterDialog() {
            this.change_request_status_dialog_visible = false;
        },
        addClusterNewBreak() {
            if (this.checkClusterBreaks) {
                let obj = { start_time: '', end_time: '' };
                this.selected_emp.breaks.push(obj);
                this.$forceUpdate();
            }
        },
        removeClusterBreak(item, index) {
            if (this.checkClusterBreaks) {
                this.selected_emp.breaks.splice(index, 1);
                this.$forceUpdate();
            }
        },

        sendRequest(){
            this.$validator.validateAll().then(result => {
                if(result){
                    if(this.shift_start_time > this.shift_end_time){
                        // if start time is greater than end time
                        this.request_error = 'Start time is greater than End time';   //set error msg

                        this.request_error_dialog_visible = true;       //open request error dialog
                    } 
					else if(moment.duration(moment(this.shift_end_time, 'YYYY/MM/DD HH:mm').diff(moment(this.shift_start_time, 'YYYY/MM/DD HH:mm'))).asHours() < 3.5){
                        
                        //if start time + end time is not greater than hours then displayed error dialog  
						
						this.request_error = 'An employee can have minimum of 3.5 hours shift';   //set error msg

                        this.request_error_dialog_visible = true;       //open request error dialog
                    
                    }else{
                        this.request_error = '';        //set request error empty

                        this.is_request_in_process = true;  //enabled loader
                        
                        let request_params = {
                            company: "",
                            cluster: "",
                            employee: this.selected_emp.id,
                            date: moment(this.current_date).format('YYYY-MM-DD'),
                            start_time: this.shift_start_time,
                            end_time: this.shift_end_time,
                            function: this.selected_emp.function,
                            notes: this.notes,
                            reason: "",
                            status: "",
                            requested_by: "",
                            processed_by: "",
                            employee_name: this.selected_emp.full_name,
                            requesting_outlet: this.selected_emp.store,
                            requesting_outlet_name: this.selected_emp.store_name,
                            source_outlet: this.selected_emp.source_outlet,
                            source_outlet_name: this.selected_emp.source_outlet_name
                        }
    
                        if(this.selected_emp.status == 'PENDING'){  //if status is pending then send request id
                            request_params.id = this.selected_emp.request_id;
                        }
    
                        labourPlanningService.changeClusterRequestStatus(request_params)
                        .then(response =>{
                            if (response.status == 200) {
                                let res = JSON.parse(response.data);
                                
                                this.$notify.success({
                                    title: "Success",
                                    message: 'Request sent successfully..!'
                                });
    
                                this.availableClusterList[this.selected_emp.cluster_index].emp_list[this.selected_emp.emp_index].status = res.status ? (res.status).toUpperCase() : '';     //assign updated status
    
                                this.availableClusterList[this.selected_emp.cluster_index].emp_list[this.selected_emp.emp_index].request_id = res.id;   //assign request id
    
                                this.availableClusterList[this.selected_emp.cluster_index].emp_list[this.selected_emp.emp_index].start_time = res.start_time;   //assign start time
    
                                this.availableClusterList[this.selected_emp.cluster_index].emp_list[this.selected_emp.emp_index].end_time = res.end_time;   //assign end time
    
    
                                // console.log(this.availableClusterList[this.selected_emp.cluster_index].emp_list[this.selected_emp.emp_index])
                            }
    
                            this.is_request_in_process = false;  //disabled loader
    
                            this.change_request_status_dialog_visible = false;      //closed dialog
    
    
                            this.selected_emp = {};
                        })
                        .catch(e =>{
                            console.log('error', e.response);
    
                            this.is_request_in_process = false;  //disabled loader
                            
                            this.$notify.error({
                                title: "Error",
                                message: e.response.data
                            });
    
                            this.change_request_status_dialog_visible = false;      //closed dialog 
                        })
                    }
                }
            })

        },

        setEndTime(){
            if(this.shift_start_time && this.shift_end_time){
                if(this.shift_start_time > this.shift_end_time){
    
                    this.request_error = 'Start time is greater thatn End time';   //set error msg
    
                    this.request_error_dialog_visible = true;       //open request error dialog
                }
            }
            // var dtStart = new Date(this.shift_start_time);
            // var dtEnd = new Date(this.shift_end_time);
            // console.log(dtStart, dtEnd);
            
            // var difference_in_milliseconds = dtEnd - dtStart;
            
            // if (difference_in_milliseconds < 0){
            //     alert("End date is before start date!");
            // }
        },

        getScheduleTimeForTimePicker(start_date) {
            let start_time = '00:00';
			let interval = 30;
			let period = "m";
			let periods_in_a_day = moment.duration(1, "day").as(period);
			let time_labels = [];
			let start_time_moment = moment(start_time, "HH:mm");
			for (let i = 0; i < periods_in_a_day; i += interval) {
				start_time_moment.add(i === 0 ? 0 : interval, period);
                let obj = {
                    time: start_time_moment.format("HH:mm"),
                    // datetime: moment(start_date).format("YYYY-MM-DD HH:mm")
                    datetime: moment(start_date + ' ' + start_time_moment.format("HH:mm")).format("YYYY-MM-DD HH:mm")
                };

				time_labels.push(obj);
			}
			this.time_list = time_labels;
			// console.log("Times", time_labels);
		},

        closeChangeRequestStatusDialog(){
            this.change_request_status_dialog_visible = false;
            this.selected_emp = {};
        },
        generateAllTimeSlotForClusterShift(sDate) {
            let time_slots = this.storeTimeSlots[sDate];
            let result = [];
            time_slots.forEach((t) => {
                let obj = { label: '', value: '' };
                obj.label = moment(t, "YYYY-MM-DDTHH:mm:ss").format('hh:mm A');
                obj.value = t;
                result.push(obj);
            });
            this.cluster_start_shift_time_slots = result;
        },
        closeRequestErrorDialog(){
            this.request_error_dialog_visible = false;
        },
        generateTimeSlotsForDateTimePickerByFunc(start, end) {
            const startDateTime = moment(start);
            const endDateTime = moment(end);
            const interval = (this.staffData.forecast_and_schedule_time_interval == '00:30:00') ? 30 : 60;
            const duration = moment.duration(endDateTime.diff(startDateTime));
            const intervalMilliseconds = interval * 60 * 1000;
            let result = [];

            for (let i = 0; i <= duration.asMilliseconds(); i += intervalMilliseconds) {
                const time = moment(startDateTime).add(i, 'milliseconds');
                result.push({
                    label: time.format('h:mm A'),
                    value: time.format('YYYY-MM-DDTHH:mm:ss'),
                });
            }
            result = result.length ? result.filter((elm) => moment(elm.value) > moment(start) && moment(elm.value) < moment(end)) : ''
            return result;
        },

        generateCLTimeSlotsForDateTimePicker(start, interval, count, isFor) {
            // console.log(start, interval, count, isFor);
            let timeSlots = [];
            start = new Date(start);
            for (let i = 0; i < count; i++) {
                const currentTime = new Date(start.getTime() + i * interval * 60 * 1000);
            
                const hour = currentTime.getHours();
                const formatted24Hour = hour < 10 ? `0${hour}` : hour;
                const formatted12Hour = hour % 12 === 0 ? 12 : hour % 12;
                const minute = currentTime.getMinutes() === 0 ? '00' : currentTime.getMinutes();
                const amOrPm = hour >= 12 ? 'PM' : 'AM';
                const dateString = currentTime.toISOString().substring(0, 10);
            
                let valueDate = dateString;
                if (hour < start.getHours()) {
                const nextDay = new Date(start.getTime() + 24 * 60 * 60 * 1000);
                valueDate = nextDay.toISOString().substring(0, 10);
                }
            
                const label = `${formatted12Hour}:${minute} ${amOrPm}`;
                const value = `${valueDate}T${formatted24Hour}:${minute}:00`;
            
                timeSlots.push({ label, value });
            }
            if(isFor == 'start') {
                this.cluster_start_shift_time_slots = timeSlots;
            } else if(isFor == 'end') {
                this.cluster_end_shift_time_slots = timeSlots;
            }
        },
        // add cluster shift end time according to emp data
        addCLshiftEndTimeAccoringToEmployeeTime(){
            const interval = (this.staffData.forecast_and_schedule_time_interval == '00:30:00') ? 30 : 60;
            this.generateCLTimeSlotsForDateTimePicker(this.selected_emp.start_time, interval, interval === 30 ? 48 : 24, 'end');
            let shiftMaxDuration;
            if(this.staffData && this.selected_emp.emp_type == 'Full Time') {
                shiftMaxDuration = this.staffData.full_time_duration_day_max.slice(0,2);
            } else if(this.staffData && this.selected_emp.emp_type == 'Part Time') {
                shiftMaxDuration = this.staffData.part_time_duration_day_max.slice(0,2);
            }

            if(this.selected_emp.start_time && shiftMaxDuration){
                this.selected_emp.end_time = moment(this.selected_emp.start_time, 'YYYY-MM-DDTHH:mm:ss').add(parseInt(shiftMaxDuration) * 60, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
            }

            this.getClusterShiftDuration(this.selected_emp.start_time, this.selected_emp.end_time);
            if(this.selected_emp.end_time){
                this.checkAllClusterShiftValidation();
            }
        },
        getClusterShiftDuration(startTime, endTime) {
            let startAt = moment(startTime, 'YYYY-MM-DDTHH:mm:ss');
            let endAt = moment(endTime, 'YYYY-MM-DDTHH:mm:ss');

            let duration = endAt.diff(startAt, 'minutes');
            this.clusterShiftDuration = duration ? duration / 60 : 0;

            // Calculate Overtime
            if (this.selected_emp.emp_type == "Full Time") {
                // console.log(this.getFunctionName(this.currentShiftData.function_id).toLowerCase(), 'this.getFunctionName(this.currentShiftData.function_id).toLowerCase()')
                let maxTimeFT = this.staffData.full_time_duration_day_max;
                maxTimeFT = convertTimeToHours(maxTimeFT);
                // console.log(maxTimeFT, 'maxTimeFT');
                if (this.is_sb_malaysia) {
                    if (
                        (this.getFunctionName(this.selected_emp.function[0]).toLowerCase() == 'hospitality specialist') ||
                        (this.selected_emp.split_shifts.some((s) => this.getFunctionName(s.function).toLowerCase() == 'hospitality specialist')) ||
                        (this.getFunctionName(this.selected_emp.function[0]).toLowerCase() == 'store manager') ||
                        (this.selected_emp.split_shifts.some((s) => this.getFunctionName(s.function).toLowerCase() == 'store manager'))
                    ) {
                        this.clusterOvertimeDuration = this.clusterShiftDuration > 9.5 ? (this.clusterShiftDuration - 9.5) : 0;
                    } else {
                        this.clusterOvertimeDuration = this.clusterShiftDuration > maxTimeFT ? (this.clusterShiftDuration - maxTimeFT) : 0;
                    }
                } else {
                    this.clusterOvertimeDuration = this.clusterShiftDuration > maxTimeFT ? (this.clusterShiftDuration - maxTimeFT) : 0;
                }
            } else if (this.selected_emp.emp_type == "Part Time") {
                let maxTimePT = this.staffData.part_time_duration_day_max;
                maxTimePT = convertTimeToHours(maxTimePT);
                if (this.is_sb_malaysia) {
                    if (
                        (this.getFunctionName(this.selected_emp.function[0]).toLowerCase() == 'hospitality specialist') ||
                        (this.selected_emp.split_shifts.some((s) => this.getFunctionName(s.function).toLowerCase() == 'hospitality specialist')) ||
                        (this.getFunctionName(this.selected_emp.function[0]).toLowerCase() == 'store manager') ||
                        (this.selected_emp.split_shifts.some((s) => this.getFunctionName(s.function).toLowerCase() == 'store manager'))
                    ) {
                        this.clusterOvertimeDuration = this.clusterShiftDuration > 9.5 ? (this.clusterShiftDuration - 9.5) : 0;
                    } else {
                        this.clusterOvertimeDuration = this.clusterShiftDuration > maxTimePT ? (this.clusterShiftDuration - maxTimePT) : 0;
                    }
                } else {
                    console.log(maxTimePT, 'maxTimePT')
                    this.clusterOvertimeDuration = this.clusterShiftDuration > maxTimePT ? (this.clusterShiftDuration - maxTimePT) : 0;
                }
            }

            function convertTimeToHours(timeString) {
                var timeParts = timeString.split(':');
                var hours = parseInt(timeParts[0]);
                var minutes = parseInt(timeParts[1]);
                var totalTimeInHours = hours + (minutes / 60);
                return totalTimeInHours;
            }
        },
        getFunctionName(funcId) {
            let funcName = [];
            let func_list = [...this.function_list];
            if (funcId && func_list.length) {
                funcName = func_list.filter((fl) => fl.id == funcId);
            }
            return funcName.length ? funcName[0].function : ''
        },
        addClusterNewSplitShift(action){
      let splitLength =  this.selected_emp.split_shifts.length;
      // Check shift start and end time
      if(this.selected_emp.end_time && this.selected_emp.start_time && this.checkClusterSplit) {
        let obj = { start_time: '', function: null, end_time: this.selected_emp.end_time };
        this.selected_emp.split_shifts[splitLength - 1].end_time = '';
        this.selected_emp.split_shifts.push(obj);
        this.$forceUpdate();
      }

    },
    }

}
</script>

<style lang="scss" scoped>
.ClusterAvailability{
    .title{
        font-size: 0.8rem;
        font-weight: bold;
        text-transform: uppercase;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;
    }

//   thead, tbody, tr, td, th {
//     display: block;
//   }
//   tbody tr{
//     // border-bottom: 1px solid #bebebe;
//   }
//   tr:after {
//     content: ' ';
//     display: block;
//     visibility: hidden;
//     clear: both;
//   }
    thead th {
        // height: 25px;
        // line-height: 30px;
        height: 35px;
        text-align: left;
        color: #707070;
        background-color: #f2f2f2!important;
        text-transform: uppercase;
    }

    tbody td, thead th {
        width: 16.66%;
        // float: left;
        text-align: center;
        font-size: 13px;
    }

    td{
        height: 50px;
    }

    tbody tr{
        border-bottom: 1px solid #eee;
    }

    .status-badge{
        padding: 3px;
        border-radius: 4px;
        font-size: 0.7rem;
        max-width: 90px;
        margin: 0 auto;
    }
    .active{
        background-color: #e29d5a;
        color: #fff;
        border: 1px solid #e29d5a;
        cursor: pointer;
    }
    .in-active{
        border: 1px solid #ddd;
        background-color: #fff;
        color: #999;
        cursor: pointer;
    }
    .pending{
        border: 1px solid #c69f26;
        background-color: #c69f26;
        color: #fff;
        cursor: pointer;
    }
    .approved{
        border: 1px solid #3e8e5d;
        background-color: #3e8e5d;
        color: #fff;
        cursor: text;
    }
    .rejected{
        border: 1px solid #d60918;
        background-color: #d60918;
        color: #fff;
        cursor: text;
    }
    .action-btn {
        background-color: #E29D5A;
        border-color: #E29D5A;
        color: #fff;
    }
    .no-data-notification{
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #e29d5a;
        padding: 15px;
    }
}
</style>